import { useContext } from "react";
import { Link } from "@wdpr/groot-components";
import { Context } from "Context";

const mainClass = "syndicated-show-disney";

const ShowDisney = () => {
	const {
		config: { showDisney, brand },
		headerData: { chrome },
	} = useContext(Context);

	if (!showDisney || !chrome?.visitDisney) return null;

	return (
		<div className={mainClass}>
			<Link
				{...chrome?.visitDisney}
				className={`${mainClass}__link ${mainClass}__link--${brand}`}
			/>
		</div>
	);
};

export default ShowDisney;
